import { Box } from '@mui/material'
import { useContext } from 'react'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import CustomerDetails from './customer-details/customer-details.component'
import CarrierDetails from './carrier-details/carrier-details.component'

const AddressDetails = () => {
  const { entityTabIndex } = useContext(AddressContext) as AddressProviderValue

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        maxHeight: '100%',
        overflow: 'hidden',
        bgcolor: 'common.white',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {entityTabIndex === 0 ? (
        <CustomerDetails />
      ) : entityTabIndex === 2 ? (
        <CarrierDetails />
      ) : (
        <Box sx={{ px: 3, py: 3, color: 'text.secondary' }}>Coming soon.</Box>
      )}
    </Box>
  )
}

export default AddressDetails
